import styled from '@emotion/styled'
import { Button as MuiButton, Grid2 as Grid, Typography } from '@mui/material'
import { spacing, SpacingProps } from '@mui/system'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

import useLoggedInUser from '@/hooks/useLoggedInUser'
import useT from '@/i18n/useT'

interface ButtonProps extends SpacingProps {
  component?: React.ElementType
  to?: string
  target?: string
}

const Button = styled(MuiButton)<ButtonProps>(spacing)

const Wrapper = styled.div`
  text-align: center;
`

export const NotAuthorized = () => {
  const { handleLogout } = useLoggedInUser()
  const { t } = useT()
  return (
    <Wrapper>
      <Helmet title={t('notAuthorized.title')} />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        {t('notAuthorized.title')}
      </Typography>
      <Typography
        component="h2"
        variant="subtitle1"
        align="center"
        gutterBottom
      >
        {t('notAuthorized.description')}
      </Typography>
      <Grid container spacing={2} direction={'column'}>
        <Button
          component={Link}
          to="/"
          variant="contained"
          color="primary"
          fullWidth={false}
          mt={2}
        >
          {t('notAuthorized.returnToWebsite')}
        </Button>
        <Button
          component={Link}
          variant="contained"
          color="secondary"
          fullWidth={false}
          mt={2}
          onClick={handleLogout}
        >
          {t('notAuthorized.logout')}
        </Button>
      </Grid>
    </Wrapper>
  )
}
